__turbopack_context__.v({
  "buttonContainer": "styles-module__E_u3Lq__buttonContainer",
  "form": "styles-module__E_u3Lq__form",
  "formContainer": "styles-module__E_u3Lq__formContainer",
  "formTitle": "styles-module__E_u3Lq__formTitle",
  "loginForm": "styles-module__E_u3Lq__loginForm",
  "mobileTabs": "styles-module__E_u3Lq__mobileTabs",
  "modalFooter": "styles-module__E_u3Lq__modalFooter",
  "policyContainer": "styles-module__E_u3Lq__policyContainer",
  "policyLink": "styles-module__E_u3Lq__policyLink",
  "tabs": "styles-module__E_u3Lq__tabs",
});
